import { Box, Typography } from "@mui/material";
import React from "react";
import { colors } from "../../theme/theme";
import dayjs from "dayjs";

const SenderMsgs = ({ msg }) => {
  return (
    <Box
      sx={{
        backgroundColor: "rgba(25,34,52, 0.05)",
        borderRadius: "14px",
        p: 2,
        mb: 2,
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      <Typography
        sx={{
          fontFamily: "Mulish-Regular",
          fontSize: "13px",
          color: colors.primary,
          maxWidth: "85%",
        }}
      >
        {msg?.message}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Mulish-Light",
          fontSize: "12px",
          color: "#B0B0B0",
        }}
      >
        {dayjs(msg?.createdAt).fromNow()}
      </Typography>
    </Box>
  );
};

export default SenderMsgs;
